const schemaMap = new Map();

const english = {
    title: 'Contact Support',
    form: {
        fName: { label: 'First Name' },
        lName: { label: 'Last Name' },
        nickname: { label: 'Nickname' },
        phoneNumber: { label: 'Phone Number' },
        email: { label: 'Email' },
        emailVerification: { label: 'Email Verification' },
        subject: {
            label: 'Issue Type',
            options: [
                { value: 1, text: "Bug" },
                { value: 2, text: "Billing" },
                { value: 3, text: "Connectivity" },
                { value: 4, text: "Feedback" },
                { value: 5, text: "Improvement" }]
        },
        message: { label: 'Message' }
    },
    errors: {
        form: {
            requiredMessage: 'This filed is required.'
        },
        view: {
            title: 'Something went wrong',
            message: 'Try refreshing this page'
        }
    },
    success: {
        view: {
            title: 'Got it!',
            message: 'One of our support agents will get back to you as soon as possible'
        }
    },
    formBottomText: '',
    submitButton: 'Submit',
}

const turkey = {
    title: 'Destek İletişim',
    form: {
        fName: { label: 'Adı' },
        lName: { label: 'Soyadı' },
        nickname: { label: 'Takma Adı' },
        phoneNumber: { label: 'Telefon Numarası' },
        email: { label: 'E-posta' },
        emailVerification: { label: 'E-posta doğrulama' },
        subject: {
            label: 'Konu',
            options: [
                { value: 1, text: "Hata" },
                { value: 2, text: "Fatura" },
                { value: 3, text: "Bağlantı" },
                { value: 4, text: "Geri bildirim" },
                { value: 5, text: "İyileştirme" }]
        },
        message: { label: 'Mesaj' }
    },
    errors: {
        form: {
            requiredMessage: 'Bu alan zorunludur.'
        },
        view: {
            title: 'Hata',
            message: 'Hata oluştu, daha sonra tekrar deneyiniz.'
        }
    },
    success: {
        view: {
            title: 'Anladım!',
            message: 'Bir destek temsilcimiz en kısa süre içinde size geri dönüş yapacaktır'
        }
    },
    formBottomText: '',
    submitButton: 'Gönder',
}

const romania = {
    title: 'Asistență Contact',
    form: {
        fName: { label: 'Prenumele' },
        lName: { label: 'Numele' },
        nickname: { label: 'Porecla' },
        phoneNumber: { label: 'Numărul de Telefon' },
        email: { label: 'E-mail' },
        emailVerification: { label: 'Confirmare E-mail' },
        subject: {
            label: 'Subiect',
            options: [
                { value: 1, text: "Eroare" },
                { value: 2, text: "Factură" },
                { value: 3, text: "Conexiune" },
                { value: 4, text: "Feedback" },
                { value: 5, text: "Îmbunătățire" }]
        },
        message: { label: 'Mesaj' }
    },
    errors: {
        form: {
            requiredMessage: 'Acest câmp este obligatoriu.'
        },
        view: {
            title: 'Eroare',
            message: 'A apărut o eroare, încercați din nou mai târziu.'
        }
    },
    success: {
        view: {
            title: 'Am înţeles!',
            message: 'Unul dintre reprezentanții noștri de asistență vă va contacta cât mai curând posibil.'
        }
    },
    formBottomText: '',
    submitButton: 'Trimite ',
}

const german = {
    title: 'Support Kontaktieren',
    form: {
        fName: { label: 'Name' },
        lName: { label: 'Nachname' },
        nickname: { label: 'Nickname' },
        phoneNumber: { label: 'Handynummer' },
        email: { label: 'E-Mail' },
        emailVerification: { label: 'E-Mail Verifizierung' },
        subject: {
            label: 'Betreff',
            options: [
                { value: 1, text: "Fehler" },
                { value: 2, text: "Rechnung" },
                { value: 3, text: "Verbindung" },
                { value: 4, text: "Feedback" },
                { value: 5, text: "Verbesserung" }]
        },
        message: { label: 'Nachricht' }
    },
    errors: {
        form: {
            requiredMessage: 'Pflichtfeld.'
        },
        view: {
            title: 'Fehler',
            message: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später noch einmal.'
        }
    },
    success: {
        view: {
            title: 'Verstanden!',
            message: 'Einer unserer Support-Mitarbeiter wird Ihnen in Kürze antworten.'
        }
    },
    formBottomText: '',
    submitButton: 'Senden',
}

const greek = {
    title: 'Επικοινωνία για Υποστήριξη',
    form: {
        fName: { label: 'Όνομα' },
        lName: { label: 'Επίθετο' },
        nickname: { label: 'Επωνυμία' },
        phoneNumber: { label: 'Τηλέφωνο' },
        email: { label: 'E-Mail' },
        emailVerification: { label: 'Επαλήθευση E-Mail' },
        subject: {
            label: 'θέμα',
            options: [
                { value: 1, text: "Λάθος" },
                { value: 2, text: "Χρέωση" },
                { value: 3, text: "Σύνδεση" },
                { value: 4, text: "Ανατροφοδότηση" },
                { value: 5, text: "Βελτίωση" }]
        },
        message: { label: 'Nachricht' }
    },
    errors: {
        form: {
            requiredMessage: 'Αυτό το πεδίο είναι υποχρεωτικό.'
        },
        view: {
            title: 'Λάθος',
            message: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά αργότερα.'
        }
    },
    success: {
        view: {
            title: 'Κατάλαβα!',
            message: 'Ένας από τους αντιπροσώπους υποστήριξης θα επικοινωνήσει μαζί σας το συντομότερο δυνατό.'
        }
    },
    formBottomText: '',
    submitButton: 'Υποβολή',
}

const arabic = {
    direction:'rtl',
    title: 'اتصل بالدعم',
    form: {
        fName: { label: 'اسم شخصي' },
        lName: { label: 'اسم العائلة' },
        nickname: { label: 'الكنية' },
        phoneNumber: { label: 'رقم الهاتف' },
        email: { label: 'البريد الإلكنروني' },
        emailVerification: { label: 'تأكيد البريد الالكتروني' },
        subject: {
            label: 'الموضوع',
            options: [
                { value: 1, text: "المشكلة" },
                { value: 2, text: "الفاتورة" },
                { value: 3, text: "انقطع الاتصال" },
                { value: 4, text: "تعليق" },
                { value: 5, text: "تحسين" }
            ]
        },
        message: { label: 'الرسالة' }
    },
    errors: {
        form: {
            requiredMessage: 'هذه الخانة مطلوبة.'
        },
        view: {
            title: 'خطأ',
            message: 'حدث خطأ ما، ارجاء حاول مرة أخرى.'
        }
    },
    success: {
        view: {
            title: 'لقد فهمت!',
            message: 'ممثلي الدعم لدينا سوف يتواصل معكم في أقرب وقت'
        }
    },
    formBottomText: '',
    submitButton: 'إرسل',
}



schemaMap.set('EN', english);
schemaMap.set('TR', turkey);
schemaMap.set('RO', romania);
schemaMap.set('DE', german);
schemaMap.set('GR', greek);
schemaMap.set('AR', arabic);

export default schemaMap;